[
  {
    "category": "staff",
    "name": "Ella",
    "school": "",
    "position": "Director",
    "field": [],
    "image": "Ella.jpg",
    "isMain": false
  },
  {
    "category": "staff",
    "name": "Sarah",
    "school": "",
    "position": "Lead Project Manager",
    "field": [],
    "image": "sarah.jpg",
    "isMain": false
  },
  {
    "category": "staff",
    "name": "Yony",
    "school": "",
    "position": "Project Manager",
    "field": [],
    "image": "Yony.jpg",
    "isMain": false
  },
  {
    "category": "staff",
    "name": "Young Joong",
    "school": "",
    "position": "Project Manager",
    "field": [],
    "image": "youngjoong.png",
    "isMain": false
  },
  {
    "category": "staff",
    "name": "Duke",
    "school": "",
    "position": "Education Manager",
    "field": [],
    "image": "Duke.jpg",
    "isMain": false
  },
  {
    "category": "instructor",
    "name": "Aiden",
    "school": "서울대학교",
    "position": "",
    "field": ["데이터 사이언스"],
    "image": "aiden.jpg",
    "isMain": false
  },
  {
    "category": "instructor",
    "name": "Alice",
    "school": "서울대학교",
    "position": "",
    "field": ["AI/ML", "알고리즘"],
    "image": "alice.jpg",
    "isMain": false
  },
  {
    "category": "instructor",
    "name": "Blaire",
    "school": "Georgie Institute of Technology",
    "position": "",
    "field": ["데이터 사이언스", "알고리즘", "UI/UX", "CAE"],
    "image": "Blaire.jpg",
    "isMain": false
  },
  {
    "category": "instructor",
    "name": "Dongmin",
    "school": "연세대학교",
    "position": "",
    "field": ["로보틱스"],
    "image": "dongmin.png",
    "isMain": false
  },
  {
    "category": "instructor",
    "name": "Ellie",
    "school": "UC Berkeley",
    "position": "",
    "field": ["플스택 개발", "알고리즘", "블록체인"],
    "image": "ellie.jpg",
    "isMain": false
  },
  {
    "category": "instructor",
    "name": "Ina",
    "school": "서울대학교",
    "position": "",
    "field": ["UI/UX", "로보틱스"],
    "image": "ina.jpg",
    "isMain": false
  },
  {
    "category": "instructor",
    "name": "Jason",
    "school": "Columbia University",
    "position": "",
    "field": ["머신러닝", "딥러닝", "AI"],
    "image": "jason.jpg",
    "isMain": false
  },
  {
    "category": "instructor",
    "name": "Jingee",
    "school": "HKUST (홍콩과기대)",
    "position": "",
    "field": ["데이터 사이언스", "머신 러닝", "게임 개발"],
    "image": "jingee.jpg",
    "isMain": false
  },
  {
    "category": "instructor",
    "name": "JY",
    "school": "Carnegie Mellon University",
    "position": "",
    "field": ["알고리즘", "풀스택 개발", "UI/UX"],
    "image": "jy.jpg",
    "isMain": true
  },
  {
    "category": "instructor",
    "name": "Kevin",
    "school": "Georgia Institute of Technology",
    "position": "",
    "field": ["앱 개발", "알고리즘"],
    "image": "kevin.jpg",
    "isMain": false
  },
  {
    "category": "instructor",
    "name": "Kijun",
    "school": "HKUST (홍콩 과기대)",
    "position": "",
    "field": ["알고리즘", "데이터 사이언스"],
    "image": "kijun.jpg",
    "isMain": true
  },
  {
    "category": "instructor",
    "name": "Kikang",
    "school": "서울과학기술대학교",
    "position": "",
    "field": ["로보틱스"],
    "image": "Kikang.jpg",
    "isMain": false
  },
  {
    "category": "instructor",
    "name": "Kun",
    "school": "서강대학교",
    "position": "",
    "field": ["Data Science", "AI/ML", "Programming"],
    "image": "Kun.jpg",
    "isMain": false
  },
  {
    "category": "instructor",
    "name": "Minhong",
    "school": "건국대 기계설계학과 석사",
    "position": "",
    "field": ["임베디드 소프트웨어"],
    "image": "minhong.jpg",
    "isMain": false
  },
  {
    "category": "instructor",
    "name": "Scott",
    "school": "University of Rochester, 연세대학교 석사(CS)",
    "position": "",
    "field": ["웹 개발", "데이터 사이언스", "알고리즘"],
    "image": "scott.jpg",
    "isMain": false
  },
  {
    "category": "instructor",
    "name": "Sehyoun",
    "school": "Lehigh University",
    "position": "",
    "field": ["데이터 사이언스", "알고리즘", "백엔드 개발"],
    "image": "Sehyun.jpg",
    "isMain": false
  },
  {
    "category": "instructor",
    "name": "Sunny",
    "school": "New York University",
    "position": "",
    "field": ["풀스택 개발", "알고리즘"],
    "image": "sunny.jpg",
    "isMain": false
  },
  {
    "category": "instructor",
    "name": "Ted",
    "school": "Georgie Institute of Technology",
    "position": "",
    "field": ["알고리즘", "앱 개발"],
    "image": "ted.jpg",
    "isMain": false
  }
]
